import { AIMessage, ConversationChunk, ConversationMessage } from "./types";
import { model } from "./firebase";
import { Schema } from "firebase/vertexai";
import { isWithinTokenLimit } from "gpt-tokenizer/model/gpt-3.5-turbo";

// // Define schema for summary response
// const summarySchema = Schema.object({
//   properties: {
//     keyPoints: Schema.array({
//       items: Schema.string(),
//     }),
//   },
// });

// Define schema for summary response
const aiChatSummarySchema = Schema.object({
  properties: {
    // targetInfo: Schema.array({
    //   items: Schema.string(),
    // }),
    summary: Schema.array({
      items: Schema.string(),
    }),
    // otherInfo: Schema.array({
    //   items: Schema.string(),
    // }),
    // corrections: Schema.array({
    //   items: Schema.object({
    //     properties: {
    //       objectName: Schema.enumString({
    //         enum: ["conversationInfo"],
    //       }),
    //       index: Schema.number(),
    //       updatedInfoPoint: Schema.string(),
    //     },
    //   }),
    // }),
  },
});

export const summarizeChunk = async ({
  targetName,
  chunk,
  summary,
}: {
  targetName?: string;
  chunk: ConversationChunk;
  summary?: any | null;
}) => {
  // if (!aiChat || !aiChat.messages || aiChat.messages.length === 0) {
  //   console.log("No AI chat messages to summarize");
  //   return null;
  // }

  try {
    // Format the conversation for the model

    let formattedChat;
    if (chunk.aiChat) {
      formattedChat = prepareChatForSummarization(chunk.aiChat);
    } else {
      formattedChat = "";
    }

    let formattedConversationMessages;
    if (chunk.conversationMessages) {
      formattedConversationMessages =
        prepareConversationMessagesForSummarization(chunk.conversationMessages);
    } else {
      formattedConversationMessages = "";
    }

    const systemInstruction =
      "You are part of an app that allows Users to upload text conversations they are having with people in the real world, to get feedback and advice from an AI wingman assistant called Options AI. Your job is to extract relevant and important information from chats between the user and their AI wingman assistant, and from the conversation that the User is having in the real world with a person (which he has uploaded to the app), who we refer to as the 'target'. To clarify, we use 'chat' to refer to a conversation between the user and their AI wingman assistant, and 'conversation' to refer to a conversation between the user and the target. The information you extract will later be passed to the AI wingman, who will not have access to the conversation that you have, so your job is to make sure future AI's have a comprehensive understanding of the relevant information.";

    const contents = [
      // summary
      //   ? {
      //       role: "user",
      //       parts: [
      //         {
      //           text:
      //             "Here are all the previous extractions from both previous conversations between User and Target, and the previous chats between User and Options AI: ===" +
      //             JSON.stringify(summary) +
      //             "=== This information is not to be repeated in your generations, it's only here so you avoid repeating yourself in the summary for the current chunk.",
      //         },
      //       ],
      //     }
      //   : {
      //       role: "user",
      //       parts: [
      //         {
      //           text: "There are no previous conversations between User and Target, or User and Options AI.",
      //         },
      //       ],
      //     },
      {
        role: "user",
        parts: [
          {
            text:
              "Here are all the previous extractions from both previous conversations between User and Target, and the previous chats between User and Options AI: ===" +
              JSON.stringify(summary) +
              "=== This information is not to be repeated in your generations, it's only here so you avoid repeating yourself in the summary for the current chunk." +
              "\n\nBelow you will find two objects, the first is a batch of the latest conversation between User and Target, and below it is the chat that the user had with their AI wingman about theit conversation with the Target. Your job is to extract important information that may be useful to future AI Wingman generations. This could be information about the target, the user's relationship with them, the user's conversation with them, user preferences as far as AI wingman is concerned, things the user mentions to the AI wingman, and any other information that you think is important. Your response will be added to the existing summary, which you will have received in my (admin) previous message to you. Don't repeat information that is already in the existing summary, and only return new bullet points relevant to the current chunk (chat & conversation) that is presented to you below. If there are any mistakes or outdated information in the existing summary, provide a new bullet point that starts with 'Correction:'. Use corrections sparingly, only when it's very important to update the information. Depending on the conversation and chat, there could be a lot of important information to extract, or there could be very little, use your best judgement. Return your responses as bullet points. Specify whether the source of your information is the chat between User and AI or the conversation between User and Target, by appending (ai chat) or (conversation) respectively, to the end of your bullet point. Return only the new information, don't return any part of the existing summary, as your generations will be appended to the existing summary after the last '==end of chunk summary=='. Return the new bullet points to add after the last '==end of chunk summary=='. User & Target conversation: ===" +
              formattedConversationMessages +
              "===\n\nUser & AI chat: ===" +
              formattedChat +
              "=== Based on the above conversation and chat, return only the new bullet points to add after the last '==end of chunk summary=='.",

            // text:
            //   "Below is a chat between User and their AI wingman assistant. Extract important information from the chat. Your job is to extract information points that will be useful for future AI's to know about this AI chat, the target, the User's relationship with them, the User's conversation with them, and any other information that you think is important. Return your response as bullet points. If information about the conversation was provided to you in my (admin) previous message to you, and you notice a mistake or outdated information, provide a new bullet point that starts with 'Correction:'. Use corrections sparingly, only when it's very important to update the information. Return everything that will be useful for future AI's to know about the conversation in the specified format. It's possible that there is very little useful information, and it's possible that there is a lot. Keep in mind, your generations will be added to the existing conversation and chat summaries, so make sure not to repeat information that is already there, and to keep it coherent and up to date and relevant to future AI generations. User & AI chat: " +
            //   formattedChat,
          },
        ],
      },
    ];

    // Call the Gemini model
    const result = await model.generateContent({
      systemInstruction,
      contents,
      generationConfig: {
        responseMimeType: "application/json",
        responseSchema: aiChatSummarySchema,
      },
    });

    const response = result.response;
    const text = response.text();

    try {
      // Parse and return the response
      const formattedResponse = JSON.parse(text);
      return formattedResponse;
    } catch (parseError) {
      console.error("Error parsing Gemini response:", parseError);
      // Return raw text if parsing fails
      return { summary: text, keyPoints: [] };
    }
  } catch (error) {
    console.error("Error calling Gemini model for summarization:", error);
    throw error;
  }
};

// NOT USED
export const summarizeConversationMessages = async ({
  // targetName,
  conversationMessages,
  pastSummaries,
}: {
  targetName: string;
  conversationMessages: ConversationMessage[] | null;
  pastSummaries: any | null;
}) => {
  if (!conversationMessages || conversationMessages.length === 0) {
    console.log("No AI chat messages to summarize");
    return null;
  }

  console.log("Conversation messages:", conversationMessages);

  // try {
  //   // Format the conversation for the model
  //   // const formattedChat = prepareChatForSummarization(aiChat);

  //   // console.log("Formatted chat:", formattedChat);

  //   // Call the Gemini model
  //   const result = await model.generateContent({
  //     systemInstruction:
  //       "You are part of an app that allows Users to upload text conversations they are having with people in the real world, to get feedback and advice from an AI wingman assistant called Options AI. Your job is to extract relevant and important information from chats between the user and their AI wingman assistant, for a particular conversation the User is having in the real world with a person, who we refer to as the 'target'. To clarify, we use 'chat' to refer to a conversation between the user and their AI wingman assistant, and 'conversation' to refer to a conversation between the user and the target. The information you extract will later be passed to the AI wingman, who will not have access to the conversation that you have, so your job is to make sure future AI's have a comprehensive understanding of the relevant information. Here is the chat between User and AI: " +
  //       formattedChat,
  //     contents: [
  //       pastSummaries
  //         ? {
  //             role: "user",
  //             parts: [
  //               {
  //                 text:
  //                   "Here is all the information about both the previous conversations between User and Target, and the previous chats between User and Options AI: " +
  //                   pastSummaries,
  //               },
  //             ],
  //           }
  //         : {
  //             role: "user",
  //             parts: [
  //               {
  //                 text: "There are no previous conversations between User and Target, or User and Options AI.",
  //               },
  //             ],
  //           },
  //       {
  //         role: "user",
  //         parts: [
  //           {
  //             text:
  //               "Below is a chat between User and their AI wingman assistant. Extract relevant and important information from the chat. Your job is to extract information that will be useful for future AI's to know about this AI chat, the target, the User's relationship with them, the User's conversation with them, and any other information that you think is important. If information about the conversation was provided to you in my (admin) previous message to you, and you notice a mistake or outdated information, provide a new bullet point that starts with 'Correction:'. Use corrections sparingly, only when it's very important to update the information. Return everything that will be useful for future AI's to know about the conversation in the specified format. It's possible that there is very little useful information, and it's possible that there is a lot. Keep in mind, your generations will be added to the existing conversation and chat information, so make sure not to repeat information that is already there, and to keep it coherent and up to date. User & AI chat: " +
  //               formattedChat,
  //           },
  //         ],
  //       },
  //     ],
  //     generationConfig: {
  //       responseMimeType: "application/json",
  //       responseSchema: aiChatSummarySchema,
  //     },
  //   });

  //   console.log("Gemini response:", result);

  //   const response = result.response;
  //   const text = response.text();
  //   console.log("Raw Gemini response:", text);

  //   try {
  //     // Parse and return the response
  //     const formattedResponse = JSON.parse(text);
  //     return formattedResponse;
  //   } catch (parseError) {
  //     console.error("Error parsing Gemini response:", parseError);
  //     // Return raw text if parsing fails
  //     return { summary: text, keyPoints: [] };
  //   }
  // } catch (error) {
  //   console.error("Error calling Gemini model for summarization:", error);
  //   throw error;
  // }
};

const prepareChatForSummarization = (aiChat: { messages: AIMessage[] }) => {
  return aiChat.messages
    .map((message) => {
      if (message.role === "user") {
        // processedMessage += "User:"

        if (message.type === "replies-request") {
          return "User requested assistant to generate messages.";
        } else if (message.type === "analysis-request") {
          return "User requested assistant to analyze the previous conversation.";
        } else {
          return `User sent the following request to the assistant: "${message.content}"`;
        }
      } else if (message.role === "assistant") {
        if (message.type === "generate-messages") {
          return `Assistant generated the following messages: "${message.content}"`;
        } else if (message.type === "analyse-chat") {
          return `Assistant analyzed the previous conversation between the user and the target and provided the following analysis: "${message.content}"`;
        } else {
          return `Assistant completed the user's request: "${message.content}"`;
        }
      } else {
        return `${message.role}: ${message.content}`;
      }
    })
    .join("\n==message==\n");
};

const prepareConversationMessagesForSummarization = (
  conversationMessages: ConversationMessage[]
) => {
  console.log("Conversation messages:", conversationMessages);
  return conversationMessages
    .map((message) => {
      return `${message.sender}: ${message.content}`;
    })
    .join("\n==message==\n");
};

// // Call the Gemini model
// const result = await model.generateContent({
//   systemInstruction:
//     "You are part of an app that allows Users to send messages to an AI wingman assistant called Options AI. Your job is to extract relevant and important information from conversations between the user and their AI wingman assistant. The information you extract will later be passed to the AI wingman, who will not have access to the conversation that you have, so your job is to make sure future AI's have a comprehensive understanding of this conversation, between the User and their AI wingman.",
//   contents: [
//     {
//       role: "user",
//       parts: [
//         {
//           text:
//             "Below is a conversation between User and their AI wingman assistant. The conversation you will receive may refer to messages sent by the user to a person in the real world, which is why they are seeking the advice of AI wingman -- you will not have access to the messages sent by the user to the person in the real world. Please extract relevant and important information from the conversation. Any messages generated by the AI wingman for the user, will be between two curly brackets like this: {{message}}. Specifically, extract any relevant information about the user, the person they are speaking to in the real world (refer to them as the 'target'), any key points from the AI, and any other relevant information that you think would be important for future AI's to know. For any important words or sentences that you think might be important to retain exactly, return them in quotes. Return your response as bullet points. User & AI conversation: " +
//             formattedConversation,
//         },
//       ],
//     },
//   ],
//   generationConfig: {
//     responseMimeType: "application/json",
//     responseSchema: summarySchema,
//   },
// });

export const summarizeCurrentAIChat = async ({
  aiChat,
  pastSummary,
}: {
  aiChat: AIMessage[];
  pastSummary: AIMessage | null;
}) => {
  try {
    // Format the conversation for the model
    const formattedChat = prepareChatForSummarization({ messages: aiChat });

    const systemInstruction =
      "You are part of an app that allows Users to upload text conversations they are having with people in the real world, to get feedback and advice from an AI wingman assistant called Options AI. Your job is to extract relevant and important information from a chat between the user and their AI wingman assistant, for a particular conversation the User is having in the real world with a person, who we refer to as the 'target'. The information you extract will later be passed to the AI wingman, who will not have access to the parts of the chat that you have, so your job is to make sure future AI's have a comprehensive understanding of the relevant information.";

    const contents = [
      {
        role: "user",
        parts: [
          {
            text:
              (pastSummary
                ? "Here is a previously generated summary of the previous messages between User and AI wingman, which you will be adding to: " +
                  pastSummary.content +
                  "\n\n The messages below are not yet summarized."
                : "") +
              "\n\nBelow you will find messages between the user and their AI wingman assistant. Your job is to summarize this chat in bullet point form. Your summaries will be passed to the Options AI wingman generations, who will not have access to the messages that you are seeing, so make sure to provide all the necessary and important information. Make sure that the last bullet point pertains to the last message in the chat. Return your response as bullet points. Your goal is to cut the chat to roughly 10% of its original length. Summarize the below chat." +
              (pastSummary
                ? "Return only the new bullet points, don't return any part of the existing summary, as your generations will be appended to the existing summary. "
                : "") +
              "User & AI chat: " +
              formattedChat,
          },
        ],
      },
    ];

    // Call the Gemini model
    const result = await model.generateContent({
      systemInstruction,
      contents,
      generationConfig: {
        responseMimeType: "application/json",
        responseSchema: aiChatSummarySchema,
      },
    });

    const response = result.response;
    const text = response.text();

    const { summary } = JSON.parse(text);

    return {
      summary,
      tokensBefore: result.response.usageMetadata?.promptTokenCount,
      tokensAfter: result.response.usageMetadata?.candidatesTokenCount,
    };
  } catch (error) {
    console.error("Error calling Gemini model for summarization:", error);
    throw error;
  }
};

export const summarizeAIChatSummary = async ({
  aiChatSummary,
}: {
  aiChatSummary: string[];
}) => {
  // console.log("aiChatSummary in GEMINI", aiChatSummary);
  try {
    const systemInstruction =
      "You are part of an app that allows Users to upload text conversations they are having with people in the real world, to get feedback and advice from an AI wingman assistant called Options AI. Some of the chats that users have between User and Options AI grow to be very long, and need summarization. Sometimes, these AI Chat Summaries grow to be very long themselves, and also need summarization. Your job is to summarize these summaries. The goal is to condense the summary by about 50%.";

    const contents = [
      {
        role: "user",
        parts: [
          // {
          //   text:
          //     "Below is a summary of a chat between User and their AI wingman assistant. Your job is to summarize the summary, and extract and condense all the most important information, that will be passed to future AI generations. What is most important are specific details about this particular chat, and the relationship between User and the target, and the relationship between User and the AI wingman. Things like 'user asked AI to generate messages', 'user asked AI to analyze the conversation', are not important. Details about the target, the user's relationship with them, and the user's unique requests to AI wingman, and the user's responses to the AI's messages, are important. The goal is to reduce the summary as much as possible but still retain the most important, high level information that will be useful for future AI generations to know about this chat, to provide continuity and context. Return in the same bullet point format as the original summary, but feel free to combine multiple bullet points if they are related. Aim to summarize the summary to about 25% (i.e 1/4th) of its original length. Chat summary: " +
          //     JSON.stringify(aiChatSummary),
          // },
          {
            text:
              "Below is a summary of a chat between User and their AI wingman assistant. Your job is to summarize the summary, and extract all the most important information, that will be passed to future AI generations. What is most important are specific details about this particular chat, the relationship between User and the target (the person they are talking to in the real world), the relationship between User and the AI wingman, details about the target, the user's unique requests to AI wingman, the user's responses to the AI's messages, and AI's responses to the user's messages. The goal is to condense the summary by about 50% but still retain the most important information that will be useful for future AI generations to know about this chat, to provide continuity and context. Return in the same bullet point format as the original summary. Chat summary: " +
              JSON.stringify(aiChatSummary),
          },
        ],
      },
    ];

    // console.log("contents in GEMINI", contents);

    // Call the Gemini model
    const result = await model.generateContent({
      systemInstruction,
      contents,
      generationConfig: {
        responseMimeType: "application/json",
        responseSchema: aiChatSummarySchema,
        // maxOutputTokens: 2000,
      },
    });

    // console.log("result in GEMINI", result);

    const response = result.response;
    const text = response.text();

    // console.log("text in GEMINI", text);

    const { summary } = JSON.parse(text);

    // console.log("summary in GEMINI", summary);

    return {
      summary,
      tokensBefore: result.response.usageMetadata?.promptTokenCount,
      tokensAfter: result.response.usageMetadata?.candidatesTokenCount,
    };
  } catch (error) {
    console.error("Error calling Gemini model for summarization:", error);

    throw error;
  }
};
